import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import http from '../services/api';
import { Star, Flame, ChevronRight, Loader2 } from 'lucide-react';

/** Community-page widget: top verified-review-earning businesses this week. */
export default function ReviewedLeaderboard({ window = 'week', limit = 5 }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get('/leaderboard/reviewed', { params: { window, limit } })
      .then(r => setRows(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [window, limit]);

  if (loading) return <div className="pbb-card p-4"><Loader2 className="animate-spin text-gray-400" size={14}/></div>;
  if (rows.length === 0) return null;

  const label = { day: 'today', week: 'this week', month: 'this month', all: 'all time' }[window] || 'this week';

  return (
    <div className="pbb-card p-5" data-testid="reviewed-leaderboard">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold inline-flex items-center gap-2">
          <Flame size={16} className="text-orange-400"/> Trending — most-reviewed <span className="text-gray-400 font-normal">{label}</span>
        </div>
        <div className="text-[10px] uppercase tracking-wider text-green-400 bg-green-600/10 border border-green-600/30 px-2 py-0.5 rounded-full">Verified</div>
      </div>
      <ol className="space-y-2">
        {rows.map((r, i) => (
          <li key={r.businessId} className="flex items-center gap-3" data-testid={`reviewed-row-${i}`}>
            <div className={`w-6 h-6 rounded-full text-xs font-bold flex items-center justify-center ${i === 0 ? 'bg-yellow-400 text-black' : i === 1 ? 'bg-gray-300 text-black' : i === 2 ? 'bg-orange-400 text-black' : 'bg-[#1a2a20] text-gray-400'}`}>{i + 1}</div>
            {r.image ? <img src={r.image} alt="" className="w-9 h-9 rounded-lg object-cover"/> : <div className="w-9 h-9 rounded-lg bg-[#1a2a20]"/>}
            <div className="flex-1 min-w-0">
              <Link to={`/business/${r.businessId}`} className="text-sm font-medium truncate hover:text-green-400">{r.name}</Link>
              <div className="text-[11px] text-gray-500 truncate">{r.category} · {r.city}</div>
            </div>
            <div className="text-right">
              <div className="text-sm font-bold text-green-400">{r.reviewsInWindow}</div>
              <div className="text-[10px] text-gray-500 inline-flex items-center gap-1"><Star size={9} className="text-yellow-400 fill-yellow-400"/> {r.avgRatingInWindow ?? '—'}</div>
            </div>
          </li>
        ))}
      </ol>
      <Link to="/directory" className="mt-3 inline-flex items-center gap-1 text-green-400 text-sm hover:underline">Browse all businesses <ChevronRight size={14}/></Link>
    </div>
  );
}
